/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function(event){

    // GSAP matchMedia
    var mm = gsap.matchMedia();

    // GSAP cta animations
    var ctaContainer = document.querySelector('.wp-block-create-block-swiftpay-cta');
    var ctaSubheading = document.querySelector('.cta-header .subheading');
    var ctaHeading = document.querySelector('.cta-header h2');
    var ctaHeadingAnimated = new SplitType(ctaHeading);
    var ctaParagraph = document.querySelector('.cta-header-content p.body-1');
    var ctaMainButton = document.querySelector('.cta-header-content .ctaButton');

    var ctaImage1 = document.querySelector('.cta-images .cta-image-item-1');
    var ctaImage2 = document.querySelector('.cta-images .cta-image-item-2');
    var ctaImage3 = document.querySelector('.cta-images .cta-image-item-3');
    var ctaImage4 = document.querySelector('.cta-images .cta-image-item-4');
    var ctaImage5 = document.querySelector('.cta-images .cta-image-item-5');
    var ctaImage6 = document.querySelector('.cta-images .cta-image-item-6');
    var ctaImage7 = document.querySelector('.cta-images .cta-image-item-7');

    function initCtaScrollAnimation(){
        var ctaScrollAnimationTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: ctaContainer,
                start: "top +=80%",
                end: "bottom bottom"
            },
        });

        gsap.fromTo(ctaHeadingAnimated.chars, {
            y: 20,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            ease: "power3.inOut",
            stagger: 0.01,
            scrollTrigger: {
                trigger: ctaContainer,
                start: "top +=80%",
                end: "bottom bottom"
            }
        });

        ctaScrollAnimationTimeline.from(ctaSubheading, {
            y: 20,
            opacity: 0,
            duration: 0.2,
            ease: "power3.inOut",
        }).from(ctaParagraph, {
            y: 20,
            opacity: 0,
            duration: 0.2,
            ease: "power3.inOut",
            delay: 0.1
        }).from(ctaMainButton, {
            y: 20,
            opacity: 0,
            duration: 0.2,
            ease: "power3.inOut",
            delay: 0.1
        });

        function animateCtaImage(ctaImage, yPercent) {
            gsap.from(ctaImage, {
                yPercent: yPercent,
                ease: "power3.inOut",
                duration: 1.5,
                scrollTrigger: {
                    trigger: ctaContainer,
                    start: "-=10% top",
                    end: "top"
                }
            });
        }

        animateCtaImage(ctaImage1, 120);
        animateCtaImage(ctaImage2, 200);
        animateCtaImage(ctaImage3, 100);
        animateCtaImage(ctaImage4, 100);
        animateCtaImage(ctaImage5, 100);
        animateCtaImage(ctaImage6, 250);
        animateCtaImage(ctaImage7, 150);



        // Images cursor interaction
        mm.add("(min-width: 1024px)", function() {
            if(ctaContainer){
                var timeout;
                ctaContainer.addEventListener("mousemove", e => {
                    if(timeout) clearTimeout(timeout);
                    setTimeout(callParallax.bind(null, e), 200);
                })

                function callParallax(e){
                    parallaxIt(e, ctaImage1, -150);
                    parallaxIt(e, ctaImage2, -100);
                    parallaxIt(e, ctaImage3, -80);
                    parallaxIt(e, ctaImage4, -50);
                    parallaxIt(e, ctaImage5, -80);
                    parallaxIt(e, ctaImage6, -100);
                    parallaxIt(e, ctaImage7, -150);
                }

                function parallaxIt(e, target, movement){
                    var relX = e.pageX - ctaContainer.getBoundingClientRect().left;
                    var relY = e.pageY - ctaContainer.getBoundingClientRect().top;

                    TweenMax.to(target, 1, {


                        x: (relX - ctaContainer.getBoundingClientRect().width/2) / ctaContainer.getBoundingClientRect().width * movement,
                        //y: (relY - ctaContainer.getBoundingClientRect().height/2) / ctaContainer.getBoundingClientRect().height * movement,
                        ease: Power4.easeOut
                    })
                }
            }
        });
    }

     mm.add("(min-width: 1024px)", function() {
         initCtaScrollAnimation();
    });
});